<template>
  <div class="content-page-bg">
    <div class="content-page-inner">
      <LandingLoader v-if="loading" />

      <div v-else>
        <div class="content-page-header">
          <span class="content-page-icon"><v-icon size="22" color="#fff">mdi-compass-outline</v-icon></span>
          <span class="content-page-eyebrow">Our Purpose</span>
        </div>

        <div class="fetched-content-card">
          <div v-if="fetchedContent" v-html="fetchedContent" class="fetched-content-wrapper"></div>

          <div v-else class="fetched-content-wrapper">
            <h1>Mission & Vision</h1>
            <p>
              Our goals, values, and vision for human-wildlife coexistence in Madhya Pradesh.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LandingLoader from '../components/LandingLoader.vue';

export default {
  name: 'MissionVision',
  components: {
    LandingLoader
  },
  data() {
    return {
      loading: true,
      fetchedContent: null
    };
  },
  mounted() {
    axios.get('/content/get/mission_and_vision')
      .then(response => {
        if (response.data && response.data.status && response.data.data && response.data.data.content) {
          this.fetchedContent = response.data.data.content.content;
        }
      })
      .catch(error => {
        console.error('Error fetching Mission and Vision content:', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
